import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
import '@/plugins/index'
import '@/common/filters/index'
import './registry'

Vue.config.productionTip = false

declare global {
  interface Window {
    printer: any;
    webView: any;
  }
}

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
